import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { getApplicants ,saveJobStatus, getJobDetail, generatePdfHtml } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';

import {NotificationContainer, NotificationManager} from 'react-notifications';

import Html2Pdf from 'js-html2pdf';

import JSZip from "jszip";

class Wcapplicants extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      applicants:[],
      zipFile: null,
      detail:[]
    }
    this.getApplicants = this.getApplicants.bind(this);
    this.showListStandBy = this.showListStandBy.bind(this);
    this.showListShorlisted = this.showListShorlisted.bind(this);
    //this.downloadZipFile = this.downloadZipFile.bind(this);
    this.job_id = this.props.match.params.jobid;
  }
 

  componentDidMount() {

    let THIS = this;
    let auth_data = JSON.parse(localStorage.getItem("user_data"));
    let user_id = auth_data.login_id;

    $(document).on('click', '.default_option', function () {
      $(this).parent().toggleClass("active");
    });

    $(document).on('click', '.select_ul li', function () {

      var currentele = $(this).html();

      //alert($(this).attr('data-applicant'));
      let applicant_id = $(this).attr('data-applicant');
      let job_id = $(this).attr('data-job_id');
      let status = $(this).attr('data-status');

      let req = JSON.stringify({
        applicant_id:applicant_id,
        job_id:job_id,
        status:status,
        user_id:user_id
      })

      saveJobStatus(req).then((response) => {

          if(response.status==1){
                
            NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');

          }else{
            
            NotificationManager.error('Error saving..', 'Change Status - Job Applicant');
               
          }

      });


      $(".default_option li").html(currentele);
      $(this).parents(".select_wrap").removeClass("active");
    })

    this.getApplicants();
    this.getJobDetail();

  }

  generateZip(){

    var zip = new JSZip();
    zip.file("Hello.txt", "Hello World\n");
    zip.generateAsync({type:"blob"})
    .then(function(content) {
        // see FileSaver.js
        //saveAs(content, "example.zip");
    });

  }

 

  generatePDF= (e) =>{


    let getTeacherID = $(e.target).attr('data-teacher_id');

    let req = JSON.stringify({
      teacher_id: getTeacherID
    })
    
    generatePdfHtml(req).then((response) => {
      
          if(response.status==1){

              var html = response.html;
              
              var options = { margin:5, filename: 'profile_wiseconnect'+getTeacherID+'.pdf',  html2canvas:  { scale: 2 }, jsPDF: {unit: 'mm', format: 'a4', orientation: 'p'}};
              const exporter = new Html2Pdf(html, options);
              exporter.getPdf(true);
              
          }

   })


  }

  getJobDetail(){
    let req = JSON.stringify({
      job_id:this.job_id
    })

    getJobDetail(req).then((response) => {

        if(response.status==1){
          this.setState({detail:response.detail});
          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');

        }else{
          
          this.setState({detail:[]});
             
        }

    });

  }

  getApplicants(){


    let req = JSON.stringify({
      job_id:this.job_id,
      status:'Applied'
    })

    getApplicants(req).then((response) => {

        if(response.status==1){
          this.setState({applicants:response.list});
          //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');

        }else{
          
          this.setState({applicants:[]});
             
        }

    });

  }

  cancelPop(){
    this.setState({blockinstopenmodal:false});
  }


  handleAction = (e) =>{

    let thisaction = $(e.target);
    //alert(thisaction);
    thisaction.find('dropdown-content').addClass('show');

}

handleClick = (e) =>{
 alert(e.target);
  $(e.target).parent().find('select_wrap').toggleClass("active");

}

showListNew =  (e) =>{

$(".btn-plain").removeClass('active');

let thisaction = $(e.target);
thisaction.addClass('active');

let req = JSON.stringify({
  job_id:this.job_id,
  status:'Applied',
})

getApplicants(req).then((response) => {

    if(response.status==1){
        
      this.setState({applicants:response.list});
      //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');

    }else{
      
      NotificationManager.error('Sorry no data found..', 'Job Applicants');
      this.setState({applicants:[]});
         
    }

});

}

showListStandBy  = (e) =>{

$(".btn-plain").removeClass('active');

let thisaction = $(e.target);
thisaction.addClass('active');

let req = JSON.stringify({
  job_id:this.job_id,
  status:'On-Hold',
})

getApplicants(req).then((response) => {

    if(response.status==1){
          
      //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');
      this.setState({applicants:response.list});

    }else{
      
      NotificationManager.error('Sorry no data found..', 'Job Applicants');
      this.setState({applicants:[]});   
    }

});

}

showListShorlisted  = (e) =>{

$(".btn-plain").removeClass('active');

let thisaction = $(e.target);
thisaction.addClass('active');

let req = JSON.stringify({
  job_id:this.job_id,
  status:'Shortlisted',
})

getApplicants(req).then((response) => {

    if(response.status==1){
      
      this.setState({applicants:response.list});
      //NotificationManager.success('Changed Status Successfully',  'Change Status - Job Applicant');

    }else{
      
      NotificationManager.error('Sorry no data found..', 'Job Applicants');
      this.setState({applicants:[]});   
    }

});

}

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.value=='Other'){
      this.setState({[e.target.name+"_other_disabled"]:false});
    }
     
  };  
 
 
  
 
  render() {

    const {applicants, detail} = this.state;

    return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                    <div class="boxtitle"><img src="../../../images/profile/about.png" />View Applicants</div>


                    <div class="content-section  borderedbox">


                    <div class="flexbtns ">
                            <button class="btn-plain active" onClick={this.showListNew}>New Applicants</button> &nbsp;<button class="btn-plain" onClick={this.showListShorlisted}>Shortlisted Applicants</button> &nbsp; <button class="btn-plain" onClick={this.showListStandBy}>On-Hold Applicants</button>
                    </div>
                    
                    <div class="topsection">
                            <div class="flex noapps">
                                  <img src="../../../images/ins/applicant.png" class="icons" /> {applicants.length} Applicants : <a href={"/partner/wiseconnect/viewjob/"+this.job_id} class="spantext"> {detail.job_title}</a>

                            </div>
                    </div>



                  </div>

            <div class="content-section contentmiddle borderedbox">

              {applicants.length >0 &&
               
              <div class="flexbtns">
                    <button class="btn btn-small bluebtn" onClick={this.generateZip}>Export All ({applicants.length}) as PDFs (zip)</button>
              </div>
                
              }
               
                <div class="listingsapplicants">
            
                {applicants.length>0  && applicants.map((item, i) => { 

                
                        return <div class="eachapplicantrow">

                              <div class="iconbag"><img src={"../../../images/profile.png"}/></div>
                              <div class="jobdetail">
                                    <div class="jobname">{item.name}</div>
                                    <div class="jobclass">{item.aboutme}</div>
                                    <div class="jobattributes tags">
                                        <span class="tag">{item.job_category}</span>
                                        <span class="tag">{item.job_experience} year(s)</span>
                                        
                                    </div>
                              </div>

                              <div class="buttonsec_sm flex">
                                    
                                  <div class="select_wrap">
                                      <ul class="default_option">
                                          <li class="btn-white-full-li">
                                              <div class="option pizza">
                                                <p>{item.applied_job_status}</p>
                                              </div>
                                          </li>
                                      </ul>
                                      <ul class="select_ul">
                                          <li data-applicant={item.teacher_id} data-job_id={item.job_id} data-status="On-Hold" onClick={this.changeStatus}>
                                              <div class="option pizza">
                                               
                                                <p>On-Hold</p>
                                              </div>
                                          </li>
                                          <li data-applicant={item.teacher_id} data-job_id={item.job_id} data-status="Shortlisted" onClick={this.changeStatus}>
                                              <div class="option burger">
                                                
                                                <p>Shortlisted</p>
                                              </div>  
                                          </li>
                                          <li data-applicant={item.teacher_id} data-job_id={item.job_id} data-status="Rejected" onClick={this.changeStatus}>
                                              <div class="option ice">
                                               
                                                <p>Rejected</p>
                                              </div>  
                                          </li>
                                          
                                      </ul>
                                  </div>
                                  
                                  
                              </div>  

                              <div class="alignleft">
                                <a href={"/partner/wiseconnect/viewprofile/"+item.teacher_id+"/"+this.job_id} class="btn btn-main-full">View Profile</a>&nbsp;
                                <button onClick={this.generatePDF} data-teacher_id={item.teacher_id} class="btn btn-main-full">Download Profile</button>
                              </div>  

                               
                      </div>

                      })}

                {applicants.length==0 &&
                
                <div class="nodata">No Data</div>
                
                }

                </div>

                
                                    
                

               

            </div> 


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default Wcapplicants;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/applicants.jsx